(function(){
  const $  = (s,c=document)=>c.querySelector(s);
  const $$ = (s,c=document)=>Array.from(c.querySelectorAll(s));

  function addToCart(variantId, qty=1, props){
    return fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ id: variantId, quantity: qty, properties: props||{} })
    }).then(r=>r.json());
  }

  function addGift(variantId){
    if(!variantId || String(variantId)==='0') return Promise.resolve();
    return addToCart(variantId, 1, { _buycade_gift: 'true' });
  }

  function dailyGate(keyBase, limit=1){
    const day = new Date().toISOString().slice(0,10);
    const KD = keyBase+'_day', KC = keyBase+'_count';
    if(localStorage.getItem(KD)!==day){
      localStorage.setItem(KD,day);
      localStorage.setItem(KC,'0');
    }
    return {
      allowed: ()=> (+localStorage.getItem(KC)||0) < limit,
      inc: ()=> localStorage.setItem(KC, String((+localStorage.getItem(KC)||0)+1))
    };
  }

  function pickPercent(list){
    if(!list || !list.length) return 1;
    const v = list[Math.floor(Math.random()*list.length)];
    const pct = parseFloat(v);
    return isNaN(pct) ? 1 : pct;
  }

  function showSavings({ percent, price, msg }){
    const dlg   = document.getElementById('bc-atc-dialog');
    const msgEl = document.getElementById('bc-atc-msg');
    if(!dlg || !msgEl) return;

    const savings = Math.max(0, Math.round(price * (percent/100) * 100) / 100);

    if(percent > 0){
      msgEl.innerHTML = `${percent}% off — you save <strong>$${savings.toFixed(2)}</strong> on this item!`;
    } else {
      msgEl.innerHTML = msg || 'Sorry — no win this time. Your item is in the cart.';
    }

    if(typeof dlg.showModal === 'function'){ dlg.showModal(); }
    document.getElementById('bc-atc-close')?.addEventListener('click', ()=> dlg.close());
  }

  function boot(root){
    const variantId   = +root.dataset.variantId;
    const price       = parseFloat(root.dataset.variantPrice || '0');
    const poolPrize   = String(root.dataset.poolPrize || '1,1,1,2.5,2.5,5').split(',').map(s=>s.trim()).filter(Boolean);
    const oddsMystery = parseFloat(root.dataset.mysteryOdds || '0.35');
    const dailyLimit  = +root.dataset.dailyLimit || 1;
    const giftVariant = +root.dataset.prizeVariantId || 0;
    const gate        = dailyGate('buycade_atc_token', dailyLimit);

    const token = root.querySelector('.bc-atc__token');
    const bins  = $$('.bc-atc__bin', root);

    if(!token || !bins.length) return;

    // keyboard: Enter/Space triggers Prize flow
    token.addEventListener('keydown', (e)=>{
      if(e.key==='Enter' || e.key===' '){
        e.preventDefault();
        handleDrop('prize');
      }
    });

    // drag events
    token.addEventListener('dragstart', e=>{
      e.dataTransfer.setData('text/plain','buycade-token');
      token.classList.add('is-dragging');
    });
    token.addEventListener('dragend', ()=> token.classList.remove('is-dragging'));

    bins.forEach(bin=>{
      bin.addEventListener('dragover', e=>{
        e.preventDefault();
        bin.classList.add('is-over');
      });
      bin.addEventListener('dragleave', ()=> bin.classList.remove('is-over'));
      bin.addEventListener('drop', e=>{
        e.preventDefault();
        bin.classList.remove('is-over');
        handleDrop(bin.dataset.bin);
      });
      bin.addEventListener('click', ()=> handleDrop(bin.dataset.bin));
    });

    async function handleDrop(type){
      try{
        // Always add product to cart
        await addToCart(variantId, 1);

        if(type==='cart'){
          window.location.href = '/cart';
          return;
        }

        // Decide if there is a prize
        let hasPrize = (type === 'prize');
        if(type === 'mystery'){
          hasPrize = Math.random() < oddsMystery;
        }

        if(!hasPrize){
          showSavings({ percent: 0, price });
          return;
        }

        // Daily gate
        if(!gate.allowed()){
          showSavings({ percent: 0, price, msg: 'Daily reward already claimed. Come back tomorrow!' });
          return;
        }

        const pct = pickPercent(poolPrize); // 1, 2.5, or 5
        gate.inc();

        if(giftVariant){
          await addGift(giftVariant);
        }

        showSavings({ percent: pct, price });
      } catch(err){
        console.warn('Buycade token ATC error', err);
        window.location.href = '/cart';
      }
    }
  }

  // Initialize all game blocks on the page
  $$('[data-bc-atc="true"]').forEach(boot);
})();
